export enum Hash {
  'L' = 'L',
  'M' = 'M',
  'R' = 'R',
  'N/A' = ''
}

export enum HashSimple {
  'L' = 'L',
  'M' = 'M',
  'R' = 'R'
}
